import i18next, { InitOptions } from "i18next";
import {
    accountDetails,
    alerts,
    barrings,
    bills,
    forgotEmail,
    glossary,
    navigation,
    order,
    payment,
    portin,
    profile,
    sim,
    control,
    month,
    usage,
    common,
    footer,
    header,
    selectReason,
    address,
    validation,
    contact,
} from "./en/translation";
import {
    ELaccountDetails,
    ELalerts,
    ELbarrings,
    ELbills,
    ELforgotEmail,
    ELglossary,
    ELnavigation,
    ELorder,
    ELpayment,
    ELportin,
    ELprofile,
    ELsim,
    ELcontrol,
    ELmonth,
    ELusage,
    ELcommon,
    ELfooter,
    ELheader,
    ELselectReason,
    ELaddress,
    ELvalidation,
    ELcontact,
} from "./el/translation";
import { centsToPrice } from "src/itsf/utils/priceUtils";

export const resources = {
    en: {
        accountDetails,
        alerts,
        barrings,
        bills,
        control,
        forgotEmail,
        glossary,
        navigation,
        order,
        payment,
        portinPage: portin,
        profile,
        month,
        sim,
        usage,
        common,
        footer,
        header,
        selectReason,
        address,
        validation,
        contact,
    },
    el: {
        accountDetails: ELaccountDetails,
        alerts: ELalerts,
        barrings: ELbarrings,
        bills: ELbills,
        control: ELcontrol,
        forgotEmail: ELforgotEmail,
        glossary: ELglossary,
        navigation: ELnavigation,
        order: ELorder,
        payment: ELpayment,
        portinPage: ELportin,
        profile: ELprofile,
        month: ELmonth,
        sim: ELsim,
        usage: ELusage,
        common: ELcommon,
        footer: ELfooter,
        header: ELheader,
        selectReason: ELselectReason,
        address: ELaddress,
        validation: ELvalidation,
        contact: ELcontact,
    },
} as const;

const detectBrowserLanguage = () => navigator?.languages?.[0];

const i18nOptions: InitOptions = {
    lng: detectBrowserLanguage(),
    fallbackLng: "en",
    fallbackNS: "common",
    interpolation: {
        format: (value, format) => {
            if (format === "priceFormat") {
                return `€${centsToPrice(value)}`;
            }

            return value ? value.toString() : "";
        },
        escapeValue: false,
    },
    debug: process.env.environment === "development",
    ns: [
        "accountDetails",
        "alerts",
        "barrings",
        "offer",
        "common",
        "bills",
        "forgotEmail",
        "navigation",
        "order",
        "payment",
        "profile",
        "portin",
        "sim",
        "usage",
        "month",
        "common",
        "footer",
        "header",
        "selectReason",
        "address",
        "validation",
        "contact",
    ],
    resources,
    react: {
        useSuspense: true,
    },
};

const i18n = i18next.createInstance();

i18n.init(
    {
        ...i18nOptions,
    },
    () => {
        var urlPath = window.location.pathname;
        //console.log(urlPath);
        var lang = urlPath.split("/")[1];
        //console.log(lang);
        if (lang == null) {
            lang = "en";
        }
        i18n.changeLanguage(lang);
        return;
    }
);

export { i18n };
